import { CmsService } from './../../cms/cms.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FaqService } from '../faq.service';
import { OverlayService } from '../../services/overlay.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '../../store';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-faq-question',
    templateUrl: './faq-question.component.html',
    styleUrls: ['./faq-question.component.scss']
})
export class FaqQuestionComponent implements OnInit {
    @Input() question;
    @Input() topic;
    @Output() closeAction = new EventEmitter();

    env = environment;
    form: FormGroup;

    topics = [];
    newItem = true;
    data: any = {
        topic: { id: 0 },
    };

    tinyInit = {
        height: 500,
        menubar: false,
        image_dimensions: false,
        image_advtab: true,
        plugins: [
            'advlist autolink lists link  charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code wordcount'
        ],
        toolbar:
            'undo redo | formatselect | bold italic forecolor backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist | removeformat | image | viewImages |visualblocks | code',
    };

    pages = [];

    constructor(
        private faqService: FaqService,
        private cmsService: CmsService,
        private store: Store,
        private overlayService: OverlayService,
        private fb: FormBuilder,
    ) {
        this.form = this.fb.group({
            question: ['', [Validators.required, Validators.minLength(3)]],
            answer: ['', [Validators.required, Validators.minLength(3)]],
            topic: ['', [Validators.required]],
            linkToRoute: [0, []],
            linkToRouteText: [0, []],
            status: [true, [Validators.required]],
        });
    }

    ngOnInit(): void {
        if (this.question) {

            this.data = this.question;
            this.newItem = false;
            this.form.patchValue({
                question: this.data.question,
                topic: this.data.topicId,
                answer: this.data.answer,
                linkToRoute: this.data.linkToRoute,
                linkToRouteText: this.data.linkToRouteText,
                status: this.data.status,
            });
        } else {
            this.form.patchValue({
                topic: this.topic.id,
            });
        }
        this.getTopics();
        this.getPages();
    }

    getTopics() {
        this.faqService.findAllTopics().subscribe(data => {
            this.topics = data.data.data;
        });
    }

    getPages() {
        this.cmsService.getAll().subscribe(data => {
            this.pages = data.data;
        })
    }
    close() {
        this.overlayService.closeAll();
    }

    toggleStatus() {
        if (!this.form.value.status) {
            this.form.patchValue({ status: true });
        } else {
            this.form.patchValue({ status: false });
        }
    }

    save() {
        this.data.question = this.form.value.question;
        this.data.answer = this.form.value.answer;
        this.data.topic.id = this.form.value.topic;
        this.data.linkToRouteText = this.form.value.linkToRouteText;
        this.data.linkToRoute = this.form.value.linkToRoute;
        this.data.status = this.form.value.status;

        if (this.newItem) {
            this.faqService.createQuestion(this.data).subscribe(data => {
                this.closeAction.emit({ reload: true });
                this.close();
            });
        } else {
            this.faqService.updateQuestion(this.data).subscribe(data => {
                this.closeAction.emit({ reload: true });
                this.close();
            });
        }
    }

}
